import { r as registerInstance, h, H as Host } from './index-ih07wrgW.js';

const dynamicInputCss = ".service-calls-dynamic-input{display:block;position:relative}.service-calls-dynamic-input__dynamic-container.is-min-reached ux-icon{opacity:0.3;cursor:default}.service-calls-dynamic-input__input-container{display:flex;align-items:center;margin:0 0 10px}.service-calls-dynamic-input__input-container ux-input-field{flex:1}.service-calls-dynamic-input__input-container .ux-label__error-message{margin-left:0}.service-calls-dynamic-input__input-container ux-icon{margin:0 0 0 20px;opacity:1;cursor:pointer;transition:opacity 0.2s ease-in-out}.service-calls-dynamic-input .ux-text-link{display:inline-block;cursor:pointer;transition:color 0.2s ease-in-out}.service-calls-dynamic-input .ux-text-link.is-max-reached{color:#a6a6a6;cursor:default}";

const DynamicInput = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.baseClass = "service-calls-dynamic-input";
        this.inputIdCounter = 0;
        /** Add input text */
        this.addText = "+ add another error number";
        /** Input names with dynamically generated suffixes */
        this.inputName = "errorNumber";
        /** Initial items to be displayed */
        this.initItems = 1;
        /** Minimum items to be displayed */
        this.minItems = 1;
        /** Maximum items to be displayed */
        this.maxItems = 6;
        /** Prefilled values */
        this.prefilledValues = [];
        /** disabled input and disabled delete button */
        this.disabled = false;
        /** Regex to validate values */
        this.regex = "";
        /** Error message for invalid values */
        this.errorMessage = "";
        /** Counter for adding items  */
        this.counter = 0;
        /** Dynamic items */
        this.items = [];
        /** Minimum items reached */
        this.minReached = false;
        /** Maximum items reached */
        this.maxReached = false;
        this.addInput = () => {
            if (this.disabled)
                return;
            if (this.counter < this.maxItems) {
                this.counter++;
                this.items.push(this.createItem(""));
                this.minReached = false;
                this.checkMinMaxReached();
            }
        };
        this.removeInput = (id) => {
            if (this.disabled)
                return;
            if (this.counter > this.minItems) {
                this.counter--;
                const items = this.items.filter((item) => item.id !== id);
                this.items = items;
                this.checkMinMaxReached();
            }
        };
        this.checkMinMaxReached = () => {
            this.minReached = this.counter === this.minItems;
            this.maxReached = this.counter === this.maxItems;
        };
    }
    componentWillLoad() {
        this.setInitItems();
    }
    createItem(value) {
        return {
            value,
            id: `item-${this.inputIdCounter++}`
        };
    }
    setInitItems() {
        let count = 0;
        const items = [];
        for (let i = 0; i < this.initItems; i++) {
            count++;
            items.push(this.createItem(this.prefilledValues[i] || ""));
        }
        this.items = items;
        this.counter = count;
        this.checkMinMaxReached();
    }
    render() {
        return (h(Host, { key: 'bec1a919b84adf7b3ae70f09ac7e019ebb5750f4', class: `${this.baseClass}` }, h("div", { key: '4c8f8a14b5a6b81231e93934332e533a9b7a1620', class: `${this.baseClass}__dynamic-container ${this.minReached || this.disabled ? "is-min-reached" : ""}` }, this.items.map(({ id, value }) => {
            return (h("div", { class: `${this.baseClass}__input-container`, key: id }, h("ux-input-field", { type: "text", value: value, onUxInputChange: (e) => {
                    this.items = this.items.map((item) => {
                        if (item.id === id) {
                            return Object.assign(Object.assign({}, item), { value: e.detail.currentValue });
                        }
                        return item;
                    });
                }, name: this.inputName, disabled: this.disabled, "data-validation-regex--expression": value === "" ? "" : this.regex, "data-validation-regex--msg": this.errorMessage }), h("ux-icon", { name: "delete", onClick: () => this.removeInput(id) })));
        })), h("slot", { key: '894a85b396ad47d179264e7e08049b13f434d5d4', name: "info" }), h("div", { key: '96b29dadfb1cf97dfacbaee802671086420a8302', class: `ux-text-link ux-text-link--primary ${this.maxReached || this.disabled ? "is-max-reached" : ""}`, onClick: this.addInput }, this.addText)));
    }
    static get watchers() { return {
        "prefilledValues": ["setInitItems"]
    }; }
};
DynamicInput.style = dynamicInputCss;

export { DynamicInput as service_calls_dynamic_input };
//# sourceMappingURL=service-calls-dynamic-input.entry.js.map

//# sourceMappingURL=service-calls-dynamic-input.entry.js.map